import React from 'react';
import { useForm } from 'react-hook-form';
import employeeForm2 from '../../assets/images/employees/employeeform2.gif';

const PFInfoForm = ({ onSubmit, data, enableValidation = false }) => {
  const { register, handleSubmit, formState: { errors }, getValues } = useForm({
    defaultValues: data,
    mode: 'onSubmit',
  });

  const mergeWithExisting = (values) => ({
    ...(typeof data === 'object' && data !== null ? data : {}),
    ...values,
  });

  const getValidationRules = (field) => {
    if (!enableValidation) return {};

    const rules = {
      uanNumber: {
        validate: (value) => {
          if (!value) return true;
          return (/^\d{12}$/).test(value) || 'UAN number must be exactly 12 digits';
        },
      },
      esiNumber: {
        validate: (value) => {
          if (!value) return true;
          return (/^\d{10}$/).test(value) || 'ESI number must be exactly 10 digits';
        },
      }
    };

    return rules[field] || {};
  };

  return (
    <form
      onSubmit={handleSubmit((formData) => onSubmit({ pf: mergeWithExisting(formData) }))}
      className="d-flex flex-column"
      style={{ minHeight: '80vh' }}
    >
      <div className="row flex-grow-1">
        <div className="col-md-8">
          <div className="row g-4">
            {/* UAN Number */}
            <div className="col-12">
              <div className="form-floating">
                <input
                  type="text"
                  className={`form-control ${errors.uanNumber ? 'is-invalid' : ''}`}
                  id="uanNumber"
                  placeholder="Enter UAN Number"
                  {...register('uanNumber', getValidationRules('uanNumber'))}
                />
                <label htmlFor="uanNumber">UAN Number</label>
                {errors.uanNumber && <div className="invalid-feedback">{errors.uanNumber.message}</div>}
              </div>
            </div>

            {/* ESI Number */}
            <div className="col-12">
              <div className="form-floating">
                <input
                  type="text"
                  className={`form-control ${errors.esiNumber ? 'is-invalid' : ''}`}
                  id="esiNumber"
                  placeholder="Enter ESI Number"
                  {...register('esiNumber', getValidationRules('esiNumber'))}
                />
                <label htmlFor="esiNumber">ESI Number</label>
                {errors.esiNumber && <div className="invalid-feedback">{errors.esiNumber.message}</div>}
              </div>
            </div>
          </div>
        </div>

        {/* Right Image */}
        <div className="col-md-4">
          <div className="position-fixed bottom-25 end-0 d-none d-md-block" style={{ maxWidth: '400px', zIndex: 1 }}>
            <img 
              src={employeeForm2} 
              alt="Employee Form" 
              className="img-fluid" 
              style={{ maxHeight: '50vh' }} 
            />
          </div>
        </div>
      </div>

      {/* Back / Next Buttons */}
      <div className="mt-auto pt-4 d-flex justify-content-between">
        <button
          type="button"
          onClick={() => onSubmit({ pf: mergeWithExisting(getValues()), goBack: true })}
          className="btn btn-outline-secondary px-4"
        >
          Back
        </button>
        <button type="submit" className="btn btn-danger px-4">
          Next
        </button>
      </div>
    </form>
  );
};

export default PFInfoForm;
